module.exports = __webpack_public_path__ + "static/media/leitold_logo20.526de98a.png";